import React from 'react';
import { render } from 'react-dom';
import Badge from './badge';
import WbmImage from '../../Shared/components/wbmImage';

class OrderLine extends React.Component {
    render() {
       return (
           <div className="list-item" >
               {
                   this.props.href ?
                       <a href={this.props.href}>
                           <WbmImage
                               src={this.props.imageUrl}
                               altText={this.props.altText}
                               title={this.props.title}
                               width={this.props.width}
                               height={this.props.height}
                           />
                       </a>
                       : <WbmImage
                           src={this.props.imageUrl}
                           altText={this.props.altText}
                           title={this.props.title}
                           width={this.props.width}
                           height={this.props.height}
                         />
               }
               {
                   this.props.quantity > 0 ?
                       <Badge quantity={this.props.quantity} /> 
                       : null
               }
               {
                   this.props.descriptionText ?
                       <div className="item-description">
                           {this.props.altText}
                       </div>
                       :null
               }
               
            </div>
        );
    }
}
export default OrderLine;  